import useSWR from "swr";
import { useCreateReferralServiceAxiosInstance } from "./useCreateReferralServiceAxiosInstance.ts";
import {
  ListReferralInviteePurchasedParams,
  ListReferralInviteePurchasedResponse,
} from "./types.ts";

export function useReferredUsers(params: ListReferralInviteePurchasedParams) {
  const { createReferralServiceAxiosInstance } =
    useCreateReferralServiceAxiosInstance();

  const queryParams = new URLSearchParams({
    limit: params.limit.toString(),
    offset: params.offset.toString(),
  });

  if (params.fromDate) {
    queryParams.append("fromDate", params.fromDate);
  }
  if (params.toDate) {
    queryParams.append("toDate", params.toDate);
  }
  if (params.inviteeEmail) {
    queryParams.append("inviteeEmail", params.inviteeEmail);
  }

  const { data, isLoading, error } = useSWR(
    `/referral/list-referral-invitee-purchased?${queryParams.toString()}`,
    async () => {
      const instance = createReferralServiceAxiosInstance();
      const { data } = await instance.get<ListReferralInviteePurchasedResponse>(
        "/referral/list-referral-invitee-purchased",
        {
          params: {
            limit: params.limit,
            offset: params.offset,
            ...(params.fromDate && { fromDate: params.fromDate }),
            ...(params.toDate && { toDate: params.toDate }),
            ...(params.inviteeEmail && { inviteeEmail: params.inviteeEmail }),
          },
        },
      );
      return data;
    },
  );

  return {
    data: data ?? {
      hasNextPage: false,
      hasPreviousPage: false,
      records: [],
    },
    isLoading,
    error,
  };
}
